import SimpleDialog from './SimpleDialog';

export default SimpleDialog;
